// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Ocorrencias_BuscarOcorrenciasInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /ocorrencias/buscarOcorrencias
 *
 * Fetches occurrences/notes for a given owner entity.
 */
import { registerContract } from './validate'

export interface Ocorrencias_BuscarOcorrenciasInput {
owner: string
ownerID: number
}

registerContract('Ocorrencias_BuscarOcorrenciasInput', {
  owner:   { type: 'string',  required: true },
  ownerID: { type: 'number',  required: true },
})
